import React, { useState, useEffect, useRef } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { Box, Card, makeStyles, CardHeader, Button, CardContent, Typography, Divider, MenuItem, Grid, InputLabel, TextField, TableRow, TableContainer, TableBody, Table, TableHead, Chip, Switch, Container, DialogContentText } from '@material-ui/core';
import PageHeader from 'src/views/Common/PageHeader';
import services from '../Services';
import { useNavigate } from 'react-router-dom';
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../utils/permissionAuth';
import { Formik } from 'formik';
import * as Yup from "yup";
import { useAlert } from "react-alert";
import DeleteIcon from '@material-ui/icons/Delete';
import tokenService from '../../../utils/tokenDecoder';
import tokenDecoder from '../../../utils/tokenDecoder';
import { useParams } from 'react-router-dom';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import { LoadingComponent } from '../../../utils/newLoader';
import Page from 'src/components/Page';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  table: {
    minWidth: 550,
  },
}));

const screenCode = "SKUMASTER"

const SKUEdit = () => {

  const classes = useStyles();
  const navigate = useNavigate();
  const alert = useAlert();
  const [title, setTitle] = useState("Add SKU Details ")
  const [groups, setGroups] = useState();
  const [factories, setFactories] = useState();
  const [skuTypes, setSkuTypes] = useState();
  const [skuCategory, setSkuCategory] = useState();
  const [measuringUnitData, setMeasuringUnitData] = useState();
  const [isUpdate, setIsUpdate] = useState(false);
  const [ArrayField, setArrayField] = useState([]);
  const [sKUMasterCode, setSKUCode] = useState("");
  const [addConfirmation, setAddConfirmation] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [isAdd, setIsAdd] = useState(false);
  const [backConfirmation, setBackConfirmation] = useState(false);
  const [skuDetails, setSkuDetails] = useState({
    sKUMasterID: 0,
    groupID: 0,
    factoryID: 0,
    sKUTypeID: 0,
    sKUTypeName: '',
    sKUCategoryID: 0,
    sKUCategoryName: '',
    measuringUnitID: 0,
    measuringUnitName: '',
    sKUMasterCode: '',
    sKUMasterName: '',
    minLevel: '',
    reOrderLevel: '',
    maxLevel: '',
    sKUMasterDescription: '',
    isActive: true
  });
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false,
  });

  const { skuMasterID } = useParams();

  let decrypted = 0

  useEffect(() => {
    decrypted = atob(skuMasterID);
    if (parseInt(decrypted) !== 0) {
      setIsUpdate(true);
      getDetailsBySKUMasterID(decrypted);
    }
  }, []);

  const amountRef = useRef(null);
  const descriptionRef = useRef(null);
  const recordCount = ArrayField.length;

  useEffect(() => {
    trackPromise(getGroupsForDropdown(), getPermissions(), getSKUTypesForDropdown(), getMeasuringUnitsForDropdown());
  }, []);

  useEffect(() => {
    if (skuDetails.sKUTypeID > 0) {
      trackPromise(getSKUTCategoriesForDropdown());
    };
  }, [skuDetails.sKUTypeID]);

  useEffect(() => {
    if (skuDetails.groupID != 0) {
      trackPromise(
        getFactoriesForDropdown(skuDetails.groupID)
      );
    }
  }, [skuDetails.groupID])

  useEffect(() => {
    if (!isUpdate) {
      setSkuDetails({
        ...skuDetails,
        sKUMasterID: 0,
        groupID: 0,
        factoryID: 0,
        sKUMasterCode: '',
        reOrderLevel: '',
        maxLevel: '',
        sKUMasterDescription: '',
        sKUTypeID: 0,
        sKUTypeName: '',
        sKUCategoryID: 0,
        sKUCategoryName: '',
        measuringUnitID: 0,
        measuringUnitName: '',
        sKUMasterName: '',
        minLevel: '',
        isActive: true
      })
    }
  }, [])

  const handleClick = () => {
    navigate('/app/skuMaster/listing');
  }

  async function getPermissions() {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode == 'EDITSKUMATER');

    if (isAuthorized === undefined) {
      navigate('/404');
    }
    var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
    });

    setSkuDetails({
      ...skuDetails,
      groupID: parseInt(tokenService.getGroupIDFromToken()),
    })
  }

  function clearData() {
    setSkuDetails({
      ...skuDetails,
      sKUMasterID: 0,
      groupID: 0,
      factoryID: 0,
      sKUMasterCode: '',
      reOrderLevel: '',
      maxLevel: '',
      sKUMasterDescription: '',
      sKUTypeID: 0,
      sKUTypeName: '',
      sKUCategoryID: 0,
      sKUCategoryName: '',
      measuringUnitID: 0,
      measuringUnitName: '',
      sKUMasterName: '',
      minLevel: '',
      isActive: true
    });
    setSKUCode([])
  }

  async function getGroupsForDropdown() {
    const groups = await services.getAllGroups();
    setGroups(groups);
  }

  async function getFactoriesForDropdown(groupID) {
    const factories = await services.getAllFactoriesByGroupID(groupID);
    setFactories(factories);
  }

  async function getSKUTypesForDropdown() {
    const skuTypes = await services.GetSKUTypes();
    setSkuTypes(skuTypes);
  }

  async function getSKUTCategoriesForDropdown() {
    const SKUCategoryNames = await services.GetSKUCategoryNamesByID(skuDetails.groupID, skuDetails.sKUTypeID);
    setSkuCategory(SKUCategoryNames);
  }

  async function getMeasuringUnitsForDropdown() {
    const measuringUnitData = await services.GetMeasuringUnits();
    setMeasuringUnitData(measuringUnitData);
  }

  function generateDropDownMenu(data) {
    let items = []
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
      }
    }
    return items
  }

  function handleChange(e) {
    const target = e.target;
    const name = target.name;
    const value = target.type === "checkbox" ? target.checked : target.value;

    setSkuDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
  }

  function handleChangeNo(e) {
    const value = e.target.value.replace(/\s/g, "");
    setSKUCode(value);
  }

  function handleChangeForAmount(e) {
    const target = e.target;
    let value = target.value;

    value = value.replace(/[^0-9.]/g, '');
    const decimalParts = value.split('.');

    if (decimalParts.length > 2) {

      value = decimalParts.slice(0, 2).join('.');
    } else if (decimalParts.length === 2) {

      value = `${decimalParts[0]}.${decimalParts[1].slice(0, 2)}`;
    }

    setSkuDetails({
      ...skuDetails,
      [target.name]: value
    });
  }

  const handleKeyDown = (event, nextInputRef) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      nextInputRef.current.focus();
    }

    if (
      event.key !== "Backspace" &&
      event.key !== "Delete" &&
      event.key !== "Tab" &&
      event.key !== "ArrowLeft" &&
      event.key !== "ArrowRight" &&
      event.key !== "." &&
      (event.key < "0" || event.key > "9")
    ) {
      event.preventDefault();
    }

    if (event.key === "." && event.target.value.includes(".")) {
      event.preventDefault();
    }
  }

  async function getDetailsBySKUMasterID(skuMasterID) {
    const skuData = await services.GetDetailsBySKUMasterID(skuMasterID);
    setIsUpdate(true);
    setSkuDetails({
      ...skuDetails,
      sKUMasterID: parseInt(skuData.sKUMasterID),
      groupID: parseInt(skuData.groupID),
      factoryID: parseInt(skuData.factoryID),
      sKUTypeID: parseInt(skuData.skuTypeID),
      sKUCategoryID: parseInt(skuData.skuCategoryID),
      measuringUnitID: parseInt(skuData.measuringUnitID),
      sKUMasterCode: skuData.skuMasterCode,
      sKUMasterName: skuData.skuMasterName,
      maxLevel: skuData.maxLevel == null ? '' : parseFloat(skuData.maxLevel).toFixed(2),
      minLevel: skuData.minLevel == null ? '' : parseFloat(skuData.minLevel).toFixed(2),
      reOrderLevel: skuData.reOrderLevel == null ? '' : parseFloat(skuData.reOrderLevel).toFixed(2),
      sKUMasterDescription: skuData.skuMasterDescription,
      modifiedBy: parseInt(tokenDecoder.getUserIDFromToken()),
      createdBy: parseInt(skuData.createdBy),
      skuMasterID: parseInt(skuData.skuMasterID),
      modifiedDate: new Date().toISOString(),
      isActive: skuData.isActive,
      sKUCategoryName: skuData.skuCategoryName,
      measuringUnitName: skuData.measuringUnitName,
      sKUTypeName: skuData.skuTypeName,
    })

    setSKUCode(skuData.skuMasterCode);
    setTitle("Edit SKU Details");
  }

  async function saveDetails() {
    if (isUpdate) {
      let updateModel = {
        sKUMasterID: parseInt(atob(skuMasterID).toString()),
        groupID: parseInt(skuDetails.groupID),
        factoryID: parseInt(skuDetails.factoryID),
        sKUMasterCode: sKUMasterCode,
        reOrderLevel: skuDetails.reOrderLevel == '' ? null : parseFloat(skuDetails.reOrderLevel),
        maxLevel: skuDetails.maxLevel === '' ? null : parseFloat(skuDetails.maxLevel),
        sKUMasterDescription: skuDetails.sKUMasterDescription === '' ? null : skuDetails.sKUMasterDescription,
        budgetCodeID: parseInt(skuDetails.sKUTypeID),
        sKUCategoryID: parseInt(skuDetails.sKUCategoryID),
        sKUMasterName: skuDetails.sKUMasterName === '' ? null : skuDetails.sKUMasterName,
        minLevel: skuDetails.minLevel === '' ? null : parseFloat(skuDetails.minLevel),
        measuringUnitID: parseInt(skuDetails.measuringUnitID),
        createdBy: parseInt(tokenDecoder.getUserIDFromToken()),
        sKUTypeName: skuTypes[skuDetails.sKUTypeID],
        sKUCategoryName: skuCategory[skuDetails.sKUCategoryID],
        measuringUnitName: measuringUnitData[skuDetails.measuringUnitID],
        createdDate: new Date().toISOString()
      };

      if (skuDetails.isActive == 1 || skuDetails.isActive == 0) {
        updateModel.isActive = skuDetails.isActive == 1 ? true : false;
      }
      let updateResponse = await services.UpdateSKUData(updateModel);

      if (updateResponse.statusCode === "Success") {
        alert.success(updateResponse.message);
        setArrayField([]);
        navigate('/app/skuMaster/listing');
      } else {
        alert.error(updateResponse.message);
      }
    }
  }

  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>
          {titleName}
        </Grid>
        <Grid item md={2} xs={12}>
          <PageHeader
            onClick={handleConfirmBackOne}
          />
        </Grid>
      </Grid>
    )
  }

  function handleAdd() {
    setAddConfirmation(false)
  }

  function handleAddOpen() {
    setAddConfirmation(true)
  }

  const handleAddOnChange = () => {
    if (isProcessing) return;
    setIsProcessing(true);
    saveDetails()
    setAddConfirmation(false);
    setTimeout(() => {
      setIsProcessing(false);
    }, 1000);
  }

  function handleConfirmBackOne() {
    if (ArrayField.length != 0) {
      handleConfirmBackOpen()
    }
    else {
      handleClick()
    }
  }

  function handleConfirmBackOpen() {
    setBackConfirmation(true)
  }

  return (
    <div>
      <LoadingComponent />
      <Page
        className={classes.root}
        title={title}
      >
        <Container maxWidth={false}>
          <Formik
            initialValues={{
              groupID: skuDetails.groupID,
              factoryID: skuDetails.factoryID,
              sKUTypeID: skuDetails.sKUTypeID,
              reOrderLevel: skuDetails.reOrderLevel,
              sKUMasterCode: sKUMasterCode,
              sKUCategoryID: skuDetails.sKUCategoryID,
              measuringUnitID: skuDetails.measuringUnitID,
              sKUMasterName: skuDetails.sKUMasterName,
              maxLevel: skuDetails.maxLevel,
              sKUMasterDescription: skuDetails.sKUMasterDescription,
              minLevel: skuDetails.minLevel,
            }}

            validationSchema={
              Yup.object().shape({
                groupID: Yup.number().required('Group is required').min("1", 'Group is required'),
                factoryID: Yup.number().required('Factory is required').min("1", 'Factory is required'),
                sKUTypeID: Yup.number().required('Account Code Name is required').min("1", 'Account Code Name is required'),
                reOrderLevel: Yup.number()
                  .nullable()
                  .transform((value, originalValue) => (originalValue === '' ? null : value)).min(1, 'Re-Order Level cannot be 0')
                  .test(
                    'reOrderLevel-range',
                    'Re-Order Level must be between Min Level and Max Level',
                    function (value) {
                      if (value == null) return true;
                      const { minLevel, maxLevel } = this.parent;
                      return (minLevel == null || value >= minLevel) && (maxLevel == null || value <= maxLevel);
                    }
                  ),
                minLevel: Yup.number()
                  .transform((value, originalValue) => (originalValue.trim() === '' ? null : value))
                  .nullable()
                  .min(1, 'Min Level cannot be 0')
                  .test(
                    'minLevel-check',
                    'Min Level must be less than or equal to Max Level & Re-Order Level',
                    function (value) {
                      const { maxLevel, reOrderLevel } = this.parent;
                      if (value == null) return true;
                      if (maxLevel != null && value > maxLevel) return false;
                      if (reOrderLevel != null && value > reOrderLevel) return false;
                      return true;
                    }
                  ),
                maxLevel: Yup.number()
                  .transform((value, originalValue) => (originalValue.trim() === '' ? null : value))
                  .nullable()
                  .min(1, 'Max Level cannot be 0')
                  .test(
                    'maxLevel-check',
                    'Max Level must be greater than or equal to Min Level & Re-Order Level',
                    function (value) {
                      const { minLevel, reOrderLevel } = this.parent;
                      if (value == null) return true;
                      if (minLevel != null && value < minLevel) return false;
                      if (reOrderLevel != null && value < reOrderLevel) return false;
                      return true;
                    }
                  ),
                sKUMasterCode: Yup.string().required('SKU Code is required'),
                sKUCategoryID: Yup.number().required('SKU Category is required').min("1", 'SKU Category is required'),
                measuringUnitID: Yup.number().required('Measuring Unit is required').min("1", 'Measuring Unit is required'),
                sKUMasterName: Yup.string()
                  .required('SKU Name is required')
                  .matches(/^\S.*\S$|^\S$/, 'Spaces are not allowed at start or end'),
                sKUMasterDescription: Yup.string()
                  .max(255, 'SKU Description must be at most 255 characters')
                  .matches(/^\S.*\S$|^\S$|^$/, 'Spaces are not allowed at start or end')
                  .nullable(),
              })
            }
            onSubmit={() => trackPromise(handleAddOnChange())}
            enableReinitialize
          >
            {({
              errors,
              handleBlur,
              handleSubmit,
              touched
            }) => (
              <form onSubmit={handleSubmit}>
                <Box mt={0}>
                  <Card>
                    <CardHeader
                      title={cardTitle(title)}
                    />
                    <PerfectScrollbar>
                      <Divider />
                      <CardContent style={{ marginBottom: "2rem" }}>
                        <Grid container spacing={3}>
                          <Grid item md={4} xs={12}>
                            <InputLabel shrink id="groupID">
                              Group  *
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.groupID && errors.groupID)}
                              helperText={touched.groupID && errors.groupID}
                              fullWidth
                              name="groupID"
                              onChange={(e) => handleChange(e)}
                              value={skuDetails.groupID}
                              variant="outlined"
                              disabled={isUpdate}
                              size="small"
                              onBlur={handleBlur}
                              InputProps={{
                                readOnly: !permissionList.isGroupFilterEnabled || isAdd,
                              }}
                            >
                              <MenuItem value="0">--Select Group--</MenuItem>
                              {generateDropDownMenu(groups)}
                            </TextField>
                          </Grid>
                          <Grid item md={4} xs={12}>
                            <InputLabel shrink id="factoryID">
                              Factory  *
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.factoryID && errors.factoryID)}
                              helperText={touched.factoryID && errors.factoryID}
                              fullWidth
                              name="factoryID"
                              onChange={(e) => handleChange(e)}
                              value={skuDetails.factoryID}
                              variant="outlined"
                              disabled={isUpdate}
                              size="small"
                              onBlur={handleBlur}
                              InputProps={{
                                readOnly: !permissionList.isFactoryFilterEnabled || isAdd,
                              }}
                            >
                              <MenuItem value="0">--Select Factory--</MenuItem>
                              {generateDropDownMenu(factories)}
                            </TextField>
                          </Grid>
                          <Grid item md={4} xs={12}>
                            <InputLabel shrink id="sKUTypeID">
                              Account Code Name *
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.sKUTypeID && errors.sKUTypeID)}
                              fullWidth
                              helperText={touched.sKUTypeID && errors.sKUTypeID}
                              name="sKUTypeID"
                              placeholder='--Select Account Code--'
                              onBlur={handleBlur}
                              size='small'
                              onChange={(e) => {
                                handleChange(e)
                              }}
                              value={skuDetails.sKUTypeID}
                              variant="outlined"
                              id="sKUTypeID"
                              disabled={isUpdate}
                              inputProps={{
                                readOnly: isUpdate
                              }}
                            >
                              {generateDropDownMenu(skuTypes)}
                            </TextField>
                          </Grid>
                          <Grid item md={4} xs={12}>
                            <InputLabel shrink id="sKUCategoryID">
                              SKU Category *
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.sKUCategoryID && errors.sKUCategoryID)}
                              fullWidth
                              helperText={touched.sKUCategoryID && errors.sKUCategoryID}
                              name="sKUCategoryID"
                              placeholder='--Select SKU Category--'
                              onBlur={handleBlur}
                              size='small'
                              onChange={(e) => {
                                handleChange(e)
                              }}
                              value={skuDetails.sKUCategoryID}
                              variant="outlined"
                              id="sKUCategoryID"
                              disabled={isUpdate}
                              inputProps={{
                                readOnly: isUpdate
                              }}
                            >
                              <MenuItem value={0}>--Select SKU Category--</MenuItem>
                              {generateDropDownMenu(skuCategory)}
                            </TextField>
                          </Grid>
                          <Grid item md={4} xs={12}>
                            <InputLabel shrink id="measuringUnitID">
                              Measuring Unit *
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.measuringUnitID && errors.measuringUnitID)}
                              fullWidth
                              helperText={touched.measuringUnitID && errors.measuringUnitID}
                              name="measuringUnitID"
                              placeholder='--Select Measuring Unit--'
                              onBlur={handleBlur}
                              size='small'
                              onChange={(e) => {
                                handleChange(e)
                              }}
                              value={skuDetails.measuringUnitID}
                              variant="outlined"
                              id="measuringUnitID"
                            >
                              <MenuItem value={0}>--Select Measuring Unit--</MenuItem>
                              {generateDropDownMenu(measuringUnitData)}
                            </TextField>
                          </Grid>
                          <Grid item md={4} xs={12}>
                            <InputLabel shrink id="sKUMasterCode">
                              SKU Code *
                            </InputLabel>
                            <TextField
                              error={Boolean(touched.sKUMasterCode && errors.sKUMasterCode)}
                              helperText={touched.sKUMasterCode && errors.sKUMasterCode}
                              fullWidth
                              size='small'
                              name="sKUMasterCode"
                              onBlur={handleBlur}
                              onChange={(e) => handleChangeNo(e)}
                              value={sKUMasterCode}
                              variant="outlined"
                              disabled={isUpdate}
                              inputProps={{
                                readOnly: isUpdate
                              }}
                            />
                          </Grid>
                          <Grid item md={4} xs={12}>
                            <InputLabel shrink id="sKUMasterName">
                              SKU Name *
                            </InputLabel>
                            <TextField
                              error={Boolean(touched.sKUMasterName && errors.sKUMasterName)}
                              helperText={touched.sKUMasterName && errors.sKUMasterName}
                              fullWidth
                              size='small'
                              name="sKUMasterName"
                              onBlur={handleBlur}
                              onChange={(e) => handleChange(e)}
                              value={skuDetails.sKUMasterName}
                              variant="outlined"
                            />
                          </Grid>
                        </Grid>
                        <Grid container spacing={3}>
                          <Grid item md={4} xs={12}>
                            <InputLabel shrink id="sKUMasterDescription">
                              Description
                            </InputLabel>
                            <TextField
                              error={Boolean(touched.sKUMasterDescription && errors.sKUMasterDescription)}
                              helperText={touched.sKUMasterDescription && errors.sKUMasterDescription}
                              fullWidth
                              size='small'
                              name="sKUMasterDescription"
                              onBlur={handleBlur}
                              onChange={(e) => handleChange(e)}
                              value={skuDetails.sKUMasterDescription}
                              variant="outlined"
                              inputRef={descriptionRef}
                            />
                          </Grid>
                          <Grid item md={4} xs={12}>
                            <InputLabel shrink id="reOrderLevel">
                              Re-Order Level
                            </InputLabel>
                            <TextField
                              error={Boolean(touched.reOrderLevel && errors.reOrderLevel)}
                              fullWidth
                              helperText={touched.reOrderLevel && errors.reOrderLevel}
                              name="reOrderLevel"
                              onBlur={handleBlur}
                              size='small'
                              onChange={(e) => handleChangeForAmount(e)}
                              value={skuDetails.reOrderLevel}
                              variant="outlined"
                              inputRef={amountRef}
                              onKeyDown={(e) => handleKeyDown(e, descriptionRef)}
                              type="number"
                            >
                            </TextField>
                          </Grid>
                          <Grid item md={4} xs={12}>
                            <InputLabel shrink id="maxLevel">
                              Max Level
                            </InputLabel>
                            <TextField
                              error={Boolean(touched.maxLevel && errors.maxLevel)}
                              helperText={touched.maxLevel && errors.maxLevel}
                              fullWidth
                              size='small'
                              name="maxLevel"
                              onBlur={handleBlur}
                              onChange={(e) => handleChangeForAmount(e)}
                              value={skuDetails.maxLevel}
                              variant="outlined"
                              inputRef={amountRef}
                              onKeyDown={(e) => handleKeyDown(e, descriptionRef)}
                              type="number"
                            />
                          </Grid>
                        </Grid>
                        <Grid container spacing={3}>
                          <Grid item md={4} xs={12}>
                            <InputLabel shrink id="minLevel">
                              Min Level
                            </InputLabel>
                            <TextField
                              error={Boolean(touched.minLevel && errors.minLevel)}
                              helperText={touched.minLevel && errors.minLevel}
                              fullWidth
                              size='small'
                              name="minLevel"
                              onBlur={handleBlur}
                              onChange={(e) => handleChangeForAmount(e)}
                              value={skuDetails.minLevel}
                              variant="outlined"
                              inputRef={amountRef}
                              onKeyDown={(e) => handleKeyDown(e, descriptionRef)}
                              type="number"
                            />
                          </Grid>
                          <Grid container spacing={3} style={{ marginTop: '1rem', paddingLeft: '10px' }}>
                            <Grid item md={2} xs={12}>
                              <InputLabel shrink id="isActive">
                                Is Active
                              </InputLabel>
                              <Switch
                                checked={skuDetails.isActive}
                                onChange={handleChange}
                                name="isActive"
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid container justify="flex-end" spacing={3}>
                          {!isUpdate ?
                            <Box pr={2} style={{ marginTop: '20px' }}>
                              <Button
                                color="primary"
                                variant="outlined"
                                type="reset"
                                onClick={clearData}
                                size='small'
                              >
                                Clear
                              </Button>
                            </Box>
                            : null}
                          {!isUpdate ?
                            <Box pr={2} style={{ marginTop: '20px' }}>
                              <Button
                                color="primary"
                                variant="contained"
                                type="submit"
                                size='small'
                              >
                                {"Add"}
                              </Button>
                            </Box>
                            : null}
                        </Grid>
                        {ArrayField.length > 0 ? (
                          <Grid container spacing={2}>
                            <Grid item xs={3} style={{ marginLeft: '10px' }}>
                              <Typography color="textSecondary" gutterBottom>
                                <Chip
                                  style={{ marginLeft: '0', marginRight: '0', backgroundColor: "#FFFDD0", color: 'black', left: '0' }}
                                  icon={<AccessTimeIcon />}
                                  label={"Record Count: " + recordCount}
                                  clickable
                                  color="primary"
                                />
                              </Typography>
                            </Grid>
                          </Grid>
                        ) : null}
                        {ArrayField.length > 0 ? (
                          <Grid item xs={12}>
                            <TableContainer>
                              <Table className={classes.table} aria-label="caption table">
                                <TableHead>
                                  <TableRow>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {ArrayField.map((row, index) => {
                                    return <TableRow key={index}>
                                    </TableRow>
                                  })}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </Grid>
                        )
                          : null}
                      </CardContent>
                      <Box display="flex" justifyContent="flex-end" p={2}>
                        <Button
                          color="primary"
                          type="button"
                          variant="contained"
                          size="small"
                          onClick={() => handleAddOpen()}
                        >
                          {isUpdate ? "Update" : "Save"}
                        </Button>
                      </Box>
                    </PerfectScrollbar>
                  </Card>
                </Box>
              </form>
            )}
          </Formik>
        </Container>
        <Dialog open={addConfirmation}>
          <DialogTitle id="alert-dialog-add">
            <Typography
              color="textSecondary"
              gutterBottom
              variant="h3">
              <Box textAlign="center">
                Confirmation
              </Box>
            </Typography>
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-add-description">
              <Typography variant="h5">
                {isUpdate
                  ? "Are you sure you want to update this record?"
                  : "Are you sure you want to save this record?"}
              </Typography>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <br />
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={handleAdd} color="primary" autoFocus>
              No
            </Button>
            <Button onClick={handleAddOnChange} color="primary"
              disabled={isProcessing}>
              Yes
            </Button>
          </DialogActions>
        </Dialog>
      </Page >
    </div>
  )
}

export default SKUEdit;
